import { recipe } from "@vanilla-extract/recipes";
import { style, keyframes } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { transition } from "../../utils/transition";
import { alignVariants } from "../../utils/vanilla/alignVariants";
import { responsiveCard } from "../../utils";

const needleWobble = keyframes({
  "0%": { transform: "rotate(-3deg)" },
  "50%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(-3deg)" },
});

export const gaugeContainerStyle = recipe({
  base: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    color: theme.colors.onBackground,
  },
  variants: {
    size: {
      s: {
        width: rem(80),
        height: rem(40),
        fontSize: rem(14),
      },
      m: {
        width: rem(120),
        height: rem(60),
        fontSize: rem(16),
      },
      l: {
        width: rem(200),
        height: rem(100),
        fontSize: rem(18),
      },
      displayM: {
        width: rem(80),
        height: rem(40),
        fontSize: rem(14),
        ...responsiveCard({
          500: {
            width: rem(120),
            height: rem(60),
            fontSize: rem(16),
          },
        }),
      },
    },
    alignSelf: {
      ...alignVariants("alignSelf"),
    },
  },
  defaultVariants: {
    size: "m",
  },
});

export const gaugeTrackStyle = style({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "auto",
  overflow: "hidden",
});

export const gaugeFillStyle = style({
  transition: transition({
    property: "stroke-dashoffset",
    duration: theme.transition.duration.m,
  }),
});

export const gaugeValueStyle = style({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  fontWeight: "600",
  fontSize: "inherit",
  color: "inherit",
  zIndex: 1,
});

export const gaugePointerStyle = style({
  transformOrigin: "center bottom",
  animation: `${needleWobble} 3s ease-in-out infinite`,
});

export const trackStrokeStyle = recipe({
  base: {},
  variants: {
    variant: {
      default: {
        stroke: theme.colors.inputBorder,
      },
      background: {
        stroke: theme.colors.background,
      },
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export const valueStyle = style({
  position: "absolute",
  bottom: 0,
});
